import { IconDefaultType as IconType } from "@slhuiicon/icon";
// Todo: Do this after icons are published
// import { ICON_HEIGHT as SLH_ICON_HEIGHT } from "@slhuiicon/icon";

export enum NotificationState {
  INFO = "info",
  SUCCESS = "success",
  WARNING = "warning",
  ERROR = "error",
}

export type Icon = {
  type: IconType;
  color?: string;
};

export enum NotificationPosition {
  TOP_LEFT = "TOP_LEFT",
  TOP_RIGHT = "TOP_RIGHT",
  BOTTOM_LEFT = "BOTTOM_LEFT",
  BOTTOM_RIGHT = "BOTTOM_RIGHT",
  TOP_CENTER = "TOP_CENTER",
  BOTTOM_CENTER = "BOTTOM_CENTER",
}

export const ICON_HEIGHT = 24;

export const EVENT_NOTIFICATION_CLOSED = "notification-closed";
